module.exports = __webpack_public_path__ + "img/background.27f0cafe.png";